import { render } from "./CancionesView.vue?vue&type=template&id=21df00a3"
import script from "./CancionesView.vue?vue&type=script&lang=js"
export * from "./CancionesView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__